import { ContractMessage } from '../../../../types/ContractMessage';
import { GetContractsParams } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { usePaginationQuery } from '../../../common/hooks/usePaginationQuery';

export const useContractsPagination = (params: GetContractsParams) => {
    const nextPage = queries.contracts.pagination({
        ...params,
        page: params.page + 1,
    });

    return usePaginationQuery<ContractMessage>({
        ...queries.contracts.pagination(params),
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
